import React from "react";

const PrivacyNotice = () => {
  return (
    <div
      className="modal fade"
      id="avisoPrivacidad"
      tabIndex="-1"
      aria-labelledby="AvisoPrivacidadLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div className="modal-content privacy-modal">
          {/* Header moderno */}
          <div className="privacy-modal-header">
            <div className="privacy-header-content">
              <div className="privacy-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h5 className="privacy-title" id="AvisoPrivacidadLabel">
                Política de Privacidad
              </h5>
            </div>
            <button
              type="button"
              className="privacy-close-btn"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>

          {/* Body con secciones */}
          <div className="privacy-modal-body">
            <p className="privacy-intro">
              De conformidad con la Ley Federal de Protección de Datos
              Personales en Posesión de Particulares, se emite el presente Aviso
              de Privacidad (en lo sucesivo "el Aviso") de las empresas Govi
              Refaccionaria S.A. de C.V., Suspensiones GR S.A. de C.V., Govi San
              Nicolás S.A. de C.V., Govi La Fe S.A. de C.V., Govi Chapultepec
              S.A. de C.V. y Govi Refaccionaria No 2 S.A. de C.V. (cualquiera en
              lo sucesivo "Govi" o "Empresa"), todas con domicilio en el cual se
              mantienen los datos personales de Libramiento Noreste #9239,
              Parque Industrial Mitras, García, N.L.
            </p>

            <div className="privacy-section">
              <div className="privacy-section-header">
                <span className="privacy-section-icon">
                  <i className="fas fa-bullseye"></i>
                </span>
                <h6 className="privacy-section-title">Finalidad</h6>
              </div>
              <p className="privacy-section-content">
                La información de clientes, proveedores y empleados que recaba
                Govi por medio de usted o a través de un tercero por los
                diferentes medios, tales como electrónicos, a través de correo
                electrónico de nuestros empleados, o mediante la página web de
                la Empresa; por entrega física a cualquiera de nuestros
                empleados en cualquiera de nuestras Sucursales, Centros de
                Distribución o mediante la consulta de datos en sitios públicos,
                será debidamente resguardada en nuestras bases de datos con el
                fin de proteger la privacidad de las personas que las
                proporcionaron. La información recabada por la Empresa será
                utilizada estrictamente para los fines de la misma, tales como
                estudios para el otorgamiento de crédito, encuestas de calidad
                en el servicio, confirmaciones de saldos, alta de cuentas
                bancarias para pago a proveedores, estudio de empleados y
                candidatos a los diferentes puestos de trabajo de nuestra
                Empresa, avisos de interés de la Empresa y promoción de
                artículos para la venta.
              </p>
            </div>

            <div className="privacy-section">
              <div className="privacy-section-header">
                <span className="privacy-section-icon">
                  <i className="fas fa-clipboard-list"></i>
                </span>
                <h6 className="privacy-section-title">Datos solicitados</h6>
              </div>
              <p className="privacy-section-content">
                La información solicitada por la empresa es variada y consiste
                entre otros datos en: Nombre, RFC, CURP, teléfono fijo y/o
                celular, dirección, IFE (o alguna otra identificación como
                pasaporte o licencia), documentación que ampare la situación
                jurídica, estados de cuenta bancarios, referencias personales y
                comerciales, y en general cualquier otra documentación que la
                Empresa requiera como requisito para el otorgamiento de
                créditos, para el alta como empleado de la Empresa o para
                realizar pagos a proveedores.
              </p>
            </div>

            <div className="privacy-section">
              <div className="privacy-section-header">
                <span className="privacy-section-icon">
                  <i className="fas fa-edit"></i>
                </span>
                <h6 className="privacy-section-title">Modificaciones del Aviso</h6>
              </div>
              <p className="privacy-section-content">
                La Empresa se reserva el derecho de realizar modificaciones al
                presente Aviso de Privacidad en base a las Leyes aplicables en
                el momento, así como a las políticas internas de la Empresa,
                cuidando en todo momento la privacidad y confidencialidad de la
                información.
              </p>
            </div>

            <div className="privacy-section">
              <div className="privacy-section-header">
                <span className="privacy-section-icon">
                  <i className="fas fa-user-lock"></i>
                </span>
                <h6 className="privacy-section-title">Limitación de la información proporcionada</h6>
              </div>
              <p className="privacy-section-content">
                La persona que haya proporcionado información a la Empresa,
                tiene el derecho a acceder, ratificar, cancelar sus datos
                personales, oponerse al tratamiento de los mismos y revocar el
                consentimiento que para dicho fin nos haya otorgado; esto se
                deberá hacer mediante comunicado por escrito que deberá
                presentarse en el domicilio de la Empresa mencionado
                anteriormente, en el departamento de Recursos Humanos.
              </p>
            </div>

            <div className="privacy-update-date">
              <i className="fas fa-calendar-alt"></i>
              <span>Última actualización: 01/2026</span>
            </div>
          </div>

          {/* Footer */}
          <div className="privacy-modal-footer">
            <button
              type="button"
              className="privacy-close-button"
              data-dismiss="modal"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice;
